export default "__VITE_ASSET__DjOHRzBs__"